import type { FaireProductEntity } from "../../entity_types/product";

export const p_4b79mtm36k: FaireProductEntity = {
  token: "p_4b79mtm36k",
  type: "product",
  name: "LM-SW-1007 Lavender/Butter Puff",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/a5c607b69e16bd100f59a4d9094e87f092aa5c1f095b1d7281363851c5806429.jpeg",
  galleryImageUrls: [],
  priceDollars: 24.5,
  description: "This Lavender/Butter Puff graphic sweatshirt from Girlie Girl Originals blends playful charm with comfort. Designed for women's casual wear, it offers a silhouette with graphic details that suit boutique wardrobes. The design pairs well with other casual pieces for a feminine, fun look.",
  tags: [],
  msrpDollars: 49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:39.333Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
